// extracted by mini-css-extract-plugin
module.exports = {"link-chevron":"link-chevron__ylsuB","bold":"bold__vyMpc","left":"left__fzCUG","size-small":"size-small__NFFhZ"};